import { render, staticRenderFns } from "./VMessage.vue?vue&type=template&id=52ed1312&scoped=true"
import script from "./VMessage.vue?vue&type=script&lang=js"
export * from "./VMessage.vue?vue&type=script&lang=js"
import style0 from "./VMessage.vue?vue&type=style&index=0&id=52ed1312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed1312",
  null
  
)

export default component.exports